// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.profile-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    max-height: 90vh;
    padding: 0 0 150px;
    overflow-y: scroll;
}

.profile-container > p {
    border: 1px solid white;
    padding: 15px;
    width: 100%;
}

.profile-container form {
    border: 2px solid #f09502;
    color: white;
    background-color: #0e0f15;
    width: 49%;
    margin-bottom: 25px;
}

.profile-container form div {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.profile-container form .wallet {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid white;
}

.profile-container form .wallet button {
    display: inline-block;
}

.profile-container .legal > div {
    display: inline-block;
}

.profile-container .legal a {
    color: white;
    text-decoration: none;
}

.profile-container .legal a:hover {
    color: #f09502;
}

@media (max-width: 500px) {
    .profile-container form {
        padding: 10px !important;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile/profile/profile.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,wBAAwB;QACxB,WAAW;IACf;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.profile-container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    max-height: 90vh;\n    padding: 0 0 150px;\n    overflow-y: scroll;\n}\n\n.profile-container > p {\n    border: 1px solid white;\n    padding: 15px;\n    width: 100%;\n}\n\n.profile-container form {\n    border: 2px solid #f09502;\n    color: white;\n    background-color: #0e0f15;\n    width: 49%;\n    margin-bottom: 25px;\n}\n\n.profile-container form div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-container form .wallet {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid white;\n}\n\n.profile-container form .wallet button {\n    display: inline-block;\n}\n\n.profile-container .legal > div {\n    display: inline-block;\n}\n\n.profile-container .legal a {\n    color: white;\n    text-decoration: none;\n}\n\n.profile-container .legal a:hover {\n    color: #f09502;\n}\n\n@media (max-width: 500px) {\n    .profile-container form {\n        padding: 10px !important;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
